module.exports = __webpack_public_path__ + "img/avatar4.6bfdb4e3.png";